import pathfinder from '@fiverr-private/pathfinder';
import { PATHS, MODES, PATHFINDER, formatQueryParams, getCategorySlug, getSubCategorySlug } from '../../utils';
import type { MapperItemConfig } from './types';

export const getSubCategoryPath = (
    { categoryId, id, mode, filter, queryParams, source }: MapperItemConfig,
    locale?: string
) => {
    if (!(categoryId && id)) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(categoryId, 10)) || isNaN(parseInt(id, 10))) {
        return PATHS.ROOT;
    }

    const categorySlug = getCategorySlug(categoryId, locale);
    const subCategorySlug = getSubCategorySlug(id, locale);
    const params = {
        category_id: categorySlug,
        id: subCategorySlug,
    };

    if (mode === MODES.PRO) {
        return pathfinder(PATHFINDER.PRO_SUB_CATEGORY, params, formatQueryParams());
    }

    return pathfinder(PATHFINDER.SUB_CATEGORY, params, formatQueryParams({ filter, queryParams, source }));
};
